import React from "react";
import "../layout/sec3.css";

const Sec3Card = (props) => {
    return (
        <div className="sec3-card">
            <div className="sec3-card-content">
                <img src={props.img} className="sec3-img" alt="" />

                <h3 className="sec3-title">{props.title}</h3>
                <p className="sec3-text">{props.text}</p>

                <div className="sec3-bottom">
                    <span className="sec3-num">{props.num}</span>
                    <span className="sec3-events">Events</span>
                </div>
            </div>

            <div className={`sec3-cric ${props.c}`}></div>
        </div>
    );
};

export default Sec3Card;